import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatDialog,MatDialogModule,MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {AuthService} from '../../services/auth.service';
import {ScreenSizeService} from '../../services/screen-size.service';
import {Component,Output,EventEmitter,OnDestroy,TemplateRef,ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {Subscription} from 'rxjs';
import {NavTabService} from '../../services/nav-tab.service';
import {LEDGER_VIEWER_GROUPS} from '../../services/ledger.service';
import {NavigationFavoritesService} from '../../services/navigation-favorites.service';
import {NAVIGATION_DATA,NavItem} from './navigation-data';
import {QuickTicketComponent} from '../../components/royal-ticketing/quick-ticket.component';
@Component({selector:'app-navigation',standalone:true,imports:[QuickTicketComponent,DragDropModule,MatDialogModule,MatButtonModule,CommonModule,FormsModule,MatIconModule,MatExpansionModule],templateUrl:'./navigation.component.html',styleUrls:['./navigation.component.scss']})
export class NavigationComponent implements OnDestroy {
 @Output() onSelectNav=new EventEmitter<void>();
 @ViewChild('existingScreenPrompt') existingScreenPrompt!:TemplateRef<unknown>;
 private promptRef?:MatDialogRef<unknown>;
 pendingScreen:NavItem|null=null;
 query=''; activeKey=''; activeGroup=''; menuItems=NAVIGATION_DATA;
 private subscription:Subscription;
 constructor(public auth:AuthService, public screenSize:ScreenSizeService, public favorites:NavigationFavoritesService,private tabs:NavTabService,private dialog:MatDialog) {
   this.subscription=tabs.selectedTab$.subscribe(()=>{this.activeKey=tabs.getActiveTab()?.componentKey || '';this.activeGroup=favorites.screens.find(s=>s.componentKey.toLowerCase()===this.activeKey)?.group || '';});
 }
 canAccess(item:NavItem){
   const key=item.componentKey.toLowerCase();
   if(key==='rtsadmin')return this.auth.isInAnyGroup(['System Admins','IT Management']);
   if(key==='ledger')return this.auth.isInAnyGroup(LEDGER_VIEWER_GROUPS);
   return true;
 }
 hasVisibleScreens(group:NavItem){return (group.children||[]).some(child=>this.canAccess(child));}
 get results(){const q=this.query.trim().toLowerCase();return this.favorites.screens.filter(s=>this.canAccess(s)&&(s.title+' '+s.group+' '+(s.title==='Purchase Orders'?'PO':'')).toLowerCase().includes(q));}
 open(item:NavItem){
   if(!this.canAccess(item))return;
   if(this.tabs.getTabs().some(tab=>tab.componentKey===item.componentKey.toLowerCase())){if(this.promptRef)return;
     this.pendingScreen=item;
     this.promptRef=this.dialog.open(this.existingScreenPrompt,{width:'460px',maxWidth:'calc(100vw - 32px)',ariaLabel:'Screen already open',autoFocus:'first-tabbable',restoreFocus:true});
     this.promptRef.afterClosed().subscribe(choice=>{
       this.promptRef=undefined;this.pendingScreen=null;
       if(choice==='existing'||choice==='new')this.finishOpen(item,choice==='new');
     });return;}
   this.finishOpen(item);
 }
 private finishOpen(item:NavItem,another=false){this.pendingScreen=null;this.tabs.openScreen({title:item.title,icon:item.icon,componentKey:item.componentKey,svgIcon:item.svgIcon},another);this.onSelectNav.emit();}
 ngOnDestroy(){this.promptRef?.close();this.subscription.unsubscribe();}
}
